import { useOrganizationAreAiTermsOfUseAccepted } from '@monorepo/settings/src/hooks/useOrganizationAreAiTermsOfUseAccepted';
import { useFeatureFlags } from 'mapistry-shared/dist/api/hooks/useFeatureFlags';

export const useIsLogAiEnabled = (organizationId?: string): boolean => {
  const { hasOrgPaidForEdpAiUploader } = useFeatureFlags();
  const { areAiTermsOfUseAccepted } =
    useOrganizationAreAiTermsOfUseAccepted(organizationId);

  return !!(hasOrgPaidForEdpAiUploader && areAiTermsOfUseAccepted);
};
